import { render, staticRenderFns } from "./GasCalculatorView.vue?vue&type=template&id=22f345fe&scoped=true"
import script from "./GasCalculatorView.vue?vue&type=script&lang=ts"
export * from "./GasCalculatorView.vue?vue&type=script&lang=ts"
import style0 from "./GasCalculatorView.vue?vue&type=style&index=0&id=22f345fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f345fe",
  null
  
)

export default component.exports